import './App.css';
import Layout from './Layout';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import { Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Registro from './pages/Registro';
import Dashboard from './pages/Dashboard';
import { AuthProvider} from './components/auth/AuthProvider';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Members from './pages/app/Members';
import User from './pages/app/User';
import Org from './pages/app/Org';
import Comunidad from './pages/app/Comunidad';
import Diocesis from './pages/app/Diocesis';
import Region from './pages/app/Region';
import Nacional from './pages/app/Nacional';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import EcnPage from './pages/EcnPage';
import Equipo from './pages/app/Equipo';
import ServicesPage from './pages/app/Services';
import Presence from './pages/Presence';
import ServiciosPage from './pages/Servicios';
import Documentos from './pages/Documentos';
import DocumentosAdmin from './pages/DocumentosAdmin';
import AdminHome from './pages/app/AdminHome';
import HomeCarouselAdmin from './pages/app/HomeCarouselAdmin';
import RolesAdmin from './pages/app/RolesAdmin';
import ComunidadAdmin from './pages/app/ComunidadAdmin';
import EventsAdmin from './pages/app/EventsAdmin';
import EventsAdminDetail from './pages/app/EventsAdminDetail';
import EventsMember from './pages/app/EventsMember';

function App() {
  return <AuthProvider>
    <Routes>
    <Route path="/" element={<Layout />}>
      <Route index element={<Home />} />
      <Route path="/presencia" element={<Presence />} />
      <Route path="/servicios" element={<ServiciosPage />} />
      <Route path="/about" element={<About />} />
      <Route path="/ecn" element={<EcnPage />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/resetpassword" element={<ResetPassword />} />
      <Route path="/registro" element={<Registro />} />
      {/* <Route path="/registro" element={<RegistroDisabled />} /> */}
      <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/app/members" element={<ProtectedRoute><Members /></ProtectedRoute>} />
      <Route path="/app/members/:memberId" element={<ProtectedRoute><User /></ProtectedRoute>} />
      <Route path="/app/user" element={<ProtectedRoute><User /></ProtectedRoute>} />
      <Route path="/app/org" element={<ProtectedRoute><Org /></ProtectedRoute>} />
      <Route path="/app/org/nacional" element={<ProtectedRoute><Nacional /></ProtectedRoute>} />
      <Route path="/app/org/regiones/:regionId" element={<ProtectedRoute><Region /></ProtectedRoute>} />
      <Route path="/app/org/diocesis/:diocesisId" element={<ProtectedRoute><Diocesis /></ProtectedRoute>} />
      <Route path="/app/org/comunidades/:comunidadId" element={<ProtectedRoute><Comunidad /></ProtectedRoute>} />
      <Route path="/app/org/teams/:teamId" element={<ProtectedRoute><Equipo /></ProtectedRoute>} />
      <Route path="/app/documentos" element={<ProtectedRoute><Documentos /></ProtectedRoute>} />
      <Route path="/app/eventos" element={<ProtectedRoute><EventsMember /></ProtectedRoute>} />
      <Route path="/app/admin" element={<ProtectedRoute><AdminHome /></ProtectedRoute>} />
      <Route path="/app/admin/servicios" element={<ProtectedRoute><ServicesPage /></ProtectedRoute>} />
      <Route path="/app/admin/documentos" element={<ProtectedRoute><DocumentosAdmin /></ProtectedRoute>} />
      <Route path="/app/admin/home-carousel" element={<ProtectedRoute><HomeCarouselAdmin /></ProtectedRoute>} />
      <Route path="/app/admin/roles" element={<ProtectedRoute><RolesAdmin /></ProtectedRoute>} />
      <Route path="/app/admin/comunidades" element={<ProtectedRoute><ComunidadAdmin /></ProtectedRoute>} />
      <Route path="/app/admin/comunidades/:comunidadId" element={<ProtectedRoute><ComunidadAdmin /></ProtectedRoute>} />
      <Route path="/app/admin/eventos" element={<ProtectedRoute><EventsAdmin /></ProtectedRoute>} />
      <Route path="/app/admin/eventos/:eventId" element={<ProtectedRoute><EventsAdminDetail /></ProtectedRoute>} />
    </Route>
  </Routes>
  </AuthProvider>;
}

export default App;
